// import { AppConfig } from './Navbar';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import MenuBookTwoToneIcon from '@mui/icons-material/MenuBookTwoTone';
import SchoolTwoToneIcon from '@mui/icons-material/SchoolTwoTone';
import FolderTwoToneIcon from '@mui/icons-material/FolderTwoTone';
import { getActiveBrandConfig, getActivePrestationBrandConfig, getPathClientBrandConfig } from '../../config/environment.config';
import { AppConfig } from '../../Objects/interfaces/NavBarInterface';

const route = getActiveBrandConfig()

/**
 * Index de page des Paramètres (prof et client) : ne correspond à aucune
 * entrée du menu, rien n'y est surligné. L'index 3 est pris par « Mes
 * documents » dans le menu prof.
 */
export const SETTINGS_NAV_INDEX = 9;

/**
 * Pages du tableau de bord unifié (entrées du menu et Paramètres) : menu
 * complet, y compris sur mobile, et cloche de notifications.
 */
export const DASHBOARD_NAV_INDEXES: number[] = [0, 1, 2, 3, SETTINGS_NAV_INDEX];

export const teachrConfig: AppConfig = {
  navigationItems: [
    {
      id: 'dashboard',
      label: 'Tableau de bord',
      path: `/${route}/tableau-de-bord`,
      icon: <DashboardTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'courses',
      label: 'Mes cours',
      path: `/${route}/tableau-de-bord/${getActivePrestationBrandConfig()}`,
      icon: <MenuBookTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'students',
      label: 'Mes élèves',
      path: `/${route}/tableau-de-bord/${getPathClientBrandConfig()}`,
      icon: <SchoolTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'documents',
      label: 'Mes documents',
      path: `/${route}/tableau-de-bord/documents`,
      icon: <FolderTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    }
  ],
  showProfile: true,
  showAuthButton: true
};
export const verifiedTainerConfig: AppConfig = {
  navigationItems: [
    {
      id: 'dashboard',
      label: 'Tableau de bord',
      path: `/${route}/tableau-de-bord`,
      icon: <DashboardTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'courses',
      label: 'Mes cours',
      path: `/${route}/tableau-de-bord/${getActivePrestationBrandConfig()}`,
      icon: <MenuBookTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'students',
      label: 'Mes clients',
      path: `/${route}/tableau-de-bord/${getPathClientBrandConfig()}`,
      icon: <SchoolTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'documents',
      label: 'Mes documents',
      path: `/${route}/tableau-de-bord/documents`,
      icon: <FolderTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    }
    // « Mon Academy » n'est plus un onglet de la barre : l'accès reste dans le menu avatar (useAppBar).
  ],
  showProfile: true,
  showAuthButton: true,
  customStyles: {
    navbar: 'shadow-lg',
    button: 'rounded-full',
    text: 'font-bold'
  }
};
export const declaronsConfig: AppConfig = {
  navigationItems: [
    {
      id: 'dashboard',
      label: 'Tableau de bord',
      path: `/${route}/tableau-de-bord`,
      icon: <DashboardTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'courses',
      label: 'Mes prestations',
      path: `/${route}/tableau-de-bord/${getActivePrestationBrandConfig()}`,
      icon: <MenuBookTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'students',
      label: 'Mes clients',
      path: `/${route}/tableau-de-bord/${getPathClientBrandConfig()}`,
      icon: <SchoolTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    },
    {
      id: 'documents',
      label: 'Mes documents',
      path: `/${route}/tableau-de-bord/documents`,
      icon: <FolderTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: true
    }
  ],
  showProfile: true,
  showAuthButton: true,
  customStyles: {
    navbar: 'shadow-lg',
    button: 'rounded-full',
    text: 'font-bold'
  }
};

/**
 * Espace client : navigation propre au client connecté, commune aux trois
 * marques (seul le vocabulaire cours/prestation change). Sélectionnée par
 * useAppBar quand currentUser.isClient est vrai.
 */
export const clientNavbarConfig: AppConfig = {
  navigationItems: [
    {
      id: 'home',
      label: 'Accueil',
      path: `/${getActiveBrandConfig()}/tableau-de-bord`,
      icon: <DashboardTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: false
    },
    {
      id: 'courses',
      label: `Mes ${getActivePrestationBrandConfig("s")}`,
      path: `/${getActiveBrandConfig()}/tableau-de-bord/${getActivePrestationBrandConfig()}`,
      icon: <MenuBookTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: false
    },
    {
      id: 'documents',
      label: 'Mes documents',
      path: `/${getActiveBrandConfig()}/tableau-de-bord/documents`,
      icon: <FolderTwoToneIcon />,
      visible: true,
      requiresAuth: true,
      requiresValidation: false
    }
    // Paramètres : accessible via le menu du compte (avatar), pas via la navbar
  ],
  showProfile: true,
  showAuthButton: true
};

// Export de toutes les configurations
export const navbarConfigs = {
  teachr: teachrConfig,
  verifiedTainer: verifiedTainerConfig,
  declarons: declaronsConfig
};
